
import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Helmet } from 'react-helmet';

import api from '../../services/api';
import logoImage from '../../assets/images/logo.jpeg';
import Navbar from '../../components/common/Navbar';
import Footer from '../../components/common/Footer';

import SliderHome from '../../components/Home/SliderHome';
import WhyChooseUs from '../../components/Home/WhyChooseUs';
import UserTypes from '../../components/Home/UserTypes';
import QuoteSection from '../../components/Home/QuoteSection';
import Testimonials from '../../components/Home/Testimonials';
import TeamMember from '../../components/Home/TeamMember';
import BlogSection from '../../components/Home/BlogSection';

import Newsletter from '../../pages/PrivacyPolicy/Newsletter';

const Home = () => {
  const [testimonial] = useState([]);
  const [slides, setSlides] = useState([]);
  const [homeContent, setHomeContent] = useState(null);
  const [loading, setLoading] = useState(true);

  // Convert relative image paths to absolute URLs
  const getImageUrl = (imagePath) => {
    if (!imagePath) return '';

    if (/^https?:\/\//i.test(imagePath)) {
      return imagePath;
    }

    return `https://www.businessmateworkflow.in/${imagePath.replace(
      /^\/+/,
      ''
    )}`;
  };

  // Fetch homepage content and banners
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [homeRes, slidesRes] = await Promise.all([
          api.get('/home'),
          api.get('/banners'),
        ]);

        setHomeContent(homeRes.data.data);
        setSlides(slidesRes.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Loading screen
  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center px-3"
        style={{
          height: '100vh',
          width: '100%',
          backgroundColor: '#fff',
        }}
      >
        <img
         src={logoImage} style={{ width:'195px' }} 
          alt="Loading..."
          style={{
            maxWidth: '60vw',
            height: 'auto',
          }}
        />
      </div>
    );
  }

  // Error state
  if (!homeContent) {
    return <div>Error loading home content</div>;
  }

  return (
    <div className="home-page">

      {/* SEO */}
      <Helmet>
        <title>
          {homeContent.home_title ||
            'Top Business Services Company in India | BusinessMateWorkflow™'}
        </title>

        <meta
          name="description"
          content="BusinessMateWorkflow™ offers business partnership, outsourcing, skilled employee hiring, and business buy & sell services for business growth in India."
        />

        <meta
          name="keywords"
          content="business services company,business growth services,business consultancy services,business support services,business networking company"
        />

        <link
          rel="canonical"
          href="https://www.businessmateworkflow.in/third-party-business-services"
        />

        <meta
          property="og:title"
          content="Third-Party Business Services"
        />

        <meta
          property="og:description"
          content="Verified third-party service providers for business growth and operations support."
        />

        <meta
          property="og:image"
          content="https://www.businessmateworkflow.in/business-partenrs-service.jpg"
        />

        <meta
          property="og:url"
          content="https://www.businessmateworkflow.in/third-party-business-services"
        />
      </Helmet>

      {/* 1. Navbar */}
      <Navbar />

      {/* 2. Hero Banner */}
      <section className="hero-banner">
        <SliderHome slides={slides} />
      </section>

      {/* 3. About Us Section */}
      <section className="about-section py-4 py-md-5">
        <div className="px-3 px-md-5">
          <Row>
            <Col
              xs={12}
              md={6}
              className="mb-4 mb-md-0 text-md-start"
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: homeContent.home_about || 'Many',
                }}
              />
            </Col>

            <Col xs={12} md={6}>
              {homeContent.home_image && (
                <img
                  src={getImageUrl(homeContent.home_image)}
                  alt="About our platform"
                  className="img-fluid rounded"
                  style={{
                    width: '100%',
                    height: 'auto',
                    objectFit: 'cover',
                  }}
                />
              )}
            </Col>
          </Row>
        </div>
      </section>

      {/* 4. Why Choose Us */}
      <WhyChooseUs homeContent={homeContent} />

      {/* 5. User Types - Why Choose Us ke turant neeche */}
      <UserTypes />

      {/* 6. CTA + Valuable Ideas + Industry Experience + Budget Friendly */}
      <QuoteSection homeContent={homeContent} />

      {/* 7. Testimonials */}
      <Testimonials testimonial={testimonial} />

      {/* 8. Our Team */}
      <section
        className="py-5 py-md-5"
        style={{
          paddingTop: '4rem',
          paddingBottom: '4rem',
        }}
      >
        <div className="mb-4 mb-md-5 text-center">
          <h1
            className="fw-bold"
            style={{
              fontSize: 'clamp(1.75rem, 5vw, 2.25rem)',
            }}
          >
            Our Team
          </h1>
        </div>

        <Container className="bg-white shadow-lg rounded-3 p-3 p-md-4">
          <TeamMember />
        </Container>
      </section>

      {/* 9. Blog Section */}
      <BlogSection />

      {/* 10. Newsletter */}
      <Newsletter />

      {/* 11. Footer */}
      <Footer />

    </div>
  );
};

export default Home;